var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'icon-box-wrapper',
    _vm.hasRouteData ? 'cursor-pointer' : '',
    { 'align-left': _vm.left, 'animated': _vm.animated } ],on:{"click":_vm.handleClick}},[_c('div',{staticClass:"icon",class:("icon--" + _vm.iconType)}),_vm._v(" "),_c('div',{class:{ 'text-left': _vm.left }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }